import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class VariantService extends BaseService {
	constructor() {
		super('/variant');
	}

	public getAllByFilter(filter: VariantFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class VariantFilter extends BaseFilter {
	constructor(isVisible?: boolean | null) {
		super();
		this._isVisible = isVisible;
	}

	private _isVisible?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._isVisible != null ? { Isvisible: this._isVisible } : {}));

		return data;
	};
}

